






















































































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() appid!: string;

  requestdomain = ["https://c.api.taisam.cn","https://testc.api.taisam.cn"];

  wsrequestdomain = [];

  uploaddomain = ["https://c.api.taisam.cn","https://testc.api.taisam.cn"];

  downloaddomain = ["https://c.api.taisam.cn","https://testc.api.taisam.cn"];

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("oplatformapps/modifydomain", {
              appid: this.appid,
              action: "set",
              requestdomain: fieldValues.requestdomain,
              wsrequestdomain: fieldValues.wsrequestdomain,
              uploaddomain: fieldValues.uploaddomain,
              downloaddomain: fieldValues.downloaddomain
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);

              this.loadData1();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  mounted() {
    this.loadData1();
  }

  async loadData1() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("oplatformapps/modifydomain", {
      appid: this.appid,
      action: "get"
    });
    if (res && res.Data) {
      this.requestdomain = res.Data.requestdomain;
      this.wsrequestdomain = res.Data.wsrequestdomain;
      this.uploaddomain = res.Data.uploaddomain;
      this.downloaddomain = res.Data.downloaddomain;
    }

    this.spinLoading = false;
  }
}
